'use client'

import { getSessionStorage } from '@/lib/sessionStorage'
import {
  FunnelLatestStepKey,
  getFunnelLatestStepProperties,
  sanitizeFunnelLatestAnswers,
} from '@/lib/posthog-funnel-latest'
import { getMainLandingTrackingProps } from '@/lib/main-landing'
import posthog from 'posthog-js'
import { useEffect } from 'react'

interface FunnelLatestStepTrackerProps {
  stepKey: FunnelLatestStepKey
  profileId?: string
}

export function FunnelLatestStepTracker({ stepKey, profileId }: FunnelLatestStepTrackerProps) {
  useEffect(() => {
    const answers = sanitizeFunnelLatestAnswers(getSessionStorage('user'))

    posthog.capture('funnel_step_viewed', {
      ...getFunnelLatestStepProperties(stepKey),
      ...(profileId ? { profile_id: profileId } : {}),
      path: window.location.pathname,
      answered_questions_count: Object.keys(answers).length,
      current_answers: answers,
      ...getMainLandingTrackingProps(),
    })
  }, [profileId, stepKey])

  return null
}

export default FunnelLatestStepTracker
